import { useQuery } from '@tanstack/react-query';

import type { QueryConfig } from '@/lib/query';
import { queryKeys } from '@/lib/query';
import { useAuthStore } from '@/store/authStore';

import { authService } from '../services/authService';
import type { AuthUser } from '../types/auth';

export function useAuthMe(config?: QueryConfig<AuthUser>) {
  const accessToken = useAuthStore(state => state.accessToken);

  return useQuery({
    queryKey: queryKeys.auth.me(),
    queryFn: authService.getMe,
    enabled: !!accessToken,
    retry: false,
    ...config,
  });
}
